export default [
  {
    path: "/order",
    name: "order",
    meta: {
      title: "我的订单",
      requireAuth: true
    },
    component: () => import("./order.vue")
  },
  {
    path: "/order/detail/:sourceId",
    name: "orderDetail",
    meta: {
      title: "订单详情",
      requireAuth: true
    },
    component: () => import("./detail.vue")
  },
  {
    path: "/order/report/:id",
    name: "orderReport",
    meta: {
      title: "推荐报告",
      requireAuth: true
    },
    component: () => import("@/components/order/report")
  }
];
